$(document).ready(function () {
  var perfEntries = performance.getEntriesByType("navigation");
  // if (perfEntries[0].type === "back_forward") {
  //   location.reload();
  // }
  $(document).on({
    ajaxStart: function () {
      $(".loader").addClass("active");
    },
    ajaxStop: function () {
      $(".loader").removeClass("active");
    },
  });
  const windowLocation = theme.windowLocation;
  const helper_function = {
    add_setting_in_localstorage: function () {
      $("#select-diamond-type-popup .btn").on("click", function () {
        $(this).addClass("button-active");
        theme.set_local_storage(
          "setting-information",
          JSON.stringify(setttingProductArray)
        );
      });
    },
    add_loader_to_button: function () {
      // $('.product-form__controls-group button[type="submit"]').on(
      //   "click",
      //   function () {
      //     $(this).addClass("button-active disabled");
      //   }
      // );
    },
  };

  helper_function.add_setting_in_localstorage();
  helper_function.add_loader_to_button();

  const engagement_ring_step = {
    active_step: function (current) {
      $(".steps-wrapper .step").removeClass("active");
      $(current).addClass("active");
    },
    start_over: function () {
      $("#start-over").on("click", function () {
        theme.open_popup($("#start-over-popup"));
      });
      $("#start-over-popup .close-button").on("click", function () {
        theme.close_popup();
      });
      $("#start-over-popup .clear-ring-data").on("click", function () {
        theme.remove_local_storage("setting-information");
        theme.remove_local_storage("diamond-information");
      });
    },
    get_step_order: function () {
      const is_diamond_step_first =
        theme.get_local_storage("diamond_step_first");
      const is_ring_setting_selected = theme.get_local_storage(
        "setting-information"
      );
      const is_ring_diamond_selected = theme.get_local_storage(
        "diamond-information"
      );
      /*  when first step is diamond and second is ring and then 
       if user removes diamond then ring will become first step */
      if (
        is_ring_setting_selected &&
        !is_ring_diamond_selected &&
        is_diamond_step_first
      ) {
        theme.remove_local_storage("diamond_step_first");
        return false;
      }
      /*  when first step is ring and second is diamond and then 
       if user removes settings then diamond will become first step */
      if (
        !is_ring_setting_selected &&
        is_ring_diamond_selected &&
        !is_diamond_step_first
      ) {
        theme.set_local_storage("diamond_step_first", true);
        $(".steps-wrapper .step-2")
          .addClass("first-step")
          .find(".count")
          .text(1);
        $(".steps-wrapper .step-1").find(".count").text(2);
      }
      /* when user click diamond link first and ring is not selected 
      then diamond will become first step */
      if (is_diamond_step_first) {
        $(".steps-wrapper .step-2")
          .addClass("first-step")
          .find(".count")
          .text(1);
        $(".steps-wrapper .step-1").find(".count").text(2);
      }
    },
    set_step_order: function () {
      $(document).on("click", ".site-nav__link", function (e) {
        // e.preventDefault();
        // alert();
        const href_link = $(this).attr("href");
        const is_ring_setting_selected = theme.get_local_storage(
          "setting-information"
        );
        const is_diamond_selected = theme.get_local_storage(
          "diamond-information"
        );
        if (
          !is_ring_setting_selected &&
          href_link.indexOf("engagement-rings") < 0
        ) {
          theme.set_local_storage("diamond_step_first", true);
        } else if (!is_diamond_selected) {
          theme.remove_local_storage("diamond_step_first");
        }
      });
    },
    set_active_step: function () {
      if (
        windowLocation.indexOf(theme.ring_setting_handle) > -1 ||
        theme.get_local_storage("customRingStep") == "engagement-rings" ||
        theme.product.tags.indexOf("ring-setting-product") > -1
      ) {
        engagement_ring_step.active_step(".step-1");
      }
      if (
        windowLocation.indexOf("diamonds") > -1 ||
        theme.product.template == "diamonds"
      ) {
        engagement_ring_step.active_step(".step-2");
      }
      if (windowLocation.indexOf("final-ring") > -1) {
        engagement_ring_step.active_step(".step-3");
      }
    },
    step_update_diamond_information: function () {
      const localStepDiamond =
        JSON.parse(theme.get_local_storage("diamond-information")) || null;
      const diamondCollectionUrl =
        localStepDiamond?.current_diamond_type == "natural"
          ? `/collections/${theme.natural_diamond_handle}`
          : `/collections/${theme.lab_diamond_handle}`;

      if (localStepDiamond) {
        $(".step-2").addClass("has-active-item");
        $(".step-2 img").attr("src", localStepDiamond.image_url);
        $(".step-2 .product-link .view").attr(
          "href",
          `${theme.diamond_product_url}?sku=${localStepDiamond?.cert_num}`
        );
        $(".step-2 .product-link .change").attr(
          "href",
          `${diamondCollectionUrl}`
        );
      } else {
        $(".step-2").removeClass("has-active-item");
      }

      $(".step-2 .product-link .remove").on("click", function (e) {
        e.preventDefault();
        theme.remove_local_storage("diamond-information");
        $(".step-2 .current-diamond-option").hide();
        $(".step-2 .icon-wrapper").css("display", "flex");
        window.location.href = diamondCollectionUrl;
      });
    },
    step_update_setting_information: function () {
      const localStepSetting =
        JSON.parse(theme.get_local_storage("setting-information")) || null;
      if (localStepSetting) {
        $(".step-1").addClass("has-active-item");
        $(".step-1 .product-img img").attr("src", localStepSetting.image);
        $(".step-1 .product-link .view").attr(
          "href",
          localStepSetting.url + "?variant=" + localStepSetting.selected_variant
        );
        $(".step-1 .product-link .change").attr(
          "href",
          `/collections/${theme.ring_setting_handle}`
        );
      } else {
        $(".step-1").removeClass("has-active-item");
        $(".step-1 .current-ring-setting").hide();
      }

      $(".step-1 .product-link .remove").on("click", function (e) {
        e.preventDefault();
        theme.remove_local_storage("setting-information");
        theme.remove_local_storage("setting-url");
        // theme.remove_local_storage("final-ring-settings");
        $(".step-1 .current-ring-setting").hide();
        $(".step-1 .icon-wrapper").css("display", "flex");
        window.location.href = "/collections/" + theme.ring_setting_handle;
      });
    },
    step_update_final_step: function () {
      const localStepSetting =
        JSON.parse(theme.get_local_storage("setting-information")) || null;
      const localStepDiamond =
        JSON.parse(theme.get_local_storage("diamond-information")) || null;
      // Show start over button
      if (localStepSetting || localStepDiamond) {
        $(".start-over-button").show();
      }
      // Show 3 step information
      if (localStepSetting && localStepDiamond) {
        $(".step-3").addClass("has-active-item");
        $(".step-3 .product-img img").attr("src", localStepSetting.image);
        $(".step-3").on("click", function () {
          const diamond_shape = localStepDiamond.shape;
          const variant_id = localStepSetting.variants[diamond_shape];
          window.location.href = `${localStepSetting.url}?variant=${variant_id}&view=final-ring&diamond=${localStepDiamond.cert_num}`;
        });
      }
    },
    add_link_to_step: function () {
      $(".step-1").on("click", function (e) {
        console.log(e.target.nodeName);
        if (e.target.nodeName != "a") {
          window.location.href = `/collections/${theme.ring_setting_handle}`;
        }
      });
      $(".step-2").on("click", function (e) {
        console.log(e.target.nodeName);
        if (e.target.nodeName != "a") {
          window.location.href = `/collections/${theme.lab_diamond_handle}`;
        }
      });
    },
  };
  engagement_ring_step.set_active_step();
  engagement_ring_step.add_link_to_step();
  engagement_ring_step.step_update_diamond_information();
  engagement_ring_step.step_update_setting_information();
  engagement_ring_step.step_update_final_step();
  engagement_ring_step.set_step_order();
  engagement_ring_step.get_step_order();
  engagement_ring_step.start_over();

  // Show setting and diamond information on pdp

  // Add ring settings in step on click of ring setting button
  const setttingProductArray = {};
  $(".product-form__select-setting").on("click", function () {
    const $this = $(".product-template__container");
    const title = $this.data("title");
    const variantId = $this.find('[name="id"]').val();
    const variantShape = $this
      .find('[name="id"] option:selected')
      .data("shape_name");
    const product_price = $this
      .find('[name="id"] option:selected')
      .data("price-without-currency");
    const product_compare_price = $this
      .find('[name="id"] option:selected')
      .data("compare-price-without-currency");
    const selected_metal_color = $this
      .find(".swatch-metal-color input:checked + label")
      .data("handle");
    const variant_image = $this
      .find('[name="id"] option:selected')
      .data("variant-featured-img");
    const product_shape_array = [];
    const selected_metal_color_variant_obj = {};

    $this.find('[name="id"] option').each(function (index) {
      const option_variant_name = $(this).data("setting-handle");
      const option_variant_id = $(this).attr("value");
      const shape_name = $(this).data("shape_name");
      console.log(shape_name, selected_metal_color);
      if (
        option_variant_name.indexOf(selected_metal_color) > -1 &&
        product_shape_array.indexOf(shape_name) < 0
      ) {
        selected_metal_color_variant_obj[shape_name] = option_variant_id;
        product_shape_array.push(shape_name);
      }
    });
    let settingUrl = "/products/" + theme.product.handle;
    setttingProductArray.url = settingUrl;
    setttingProductArray.title = title;
    setttingProductArray.price = product_price;
    setttingProductArray.compare_price = product_compare_price;
    setttingProductArray.selected_variant = variantId;
    setttingProductArray.variants = selected_metal_color_variant_obj;
    setttingProductArray.shape = variantShape;
    setttingProductArray.image = variant_image;
    setttingProductArray.tags = theme.product.tags;

    if (theme.product.tags.indexOf("luxury-engagement-rings") > -1) {
      theme.set_local_storage("luxe-setting-flag", true);
    }
    // theme.set_local_storage("final-ring-settings", settingUrl);
    theme.remove_local_storage("customRingStep");
    if (theme.get_local_storage("diamond-information")) {
      const diamond_information = JSON.parse(
        theme.get_local_storage("diamond-information")
      );
      const diamond_shape = diamond_information.shape;
      const variant_id = setttingProductArray.variants[diamond_shape];
      // Add settings information in local storage
      theme.set_local_storage(
        "setting-information",
        JSON.stringify(setttingProductArray)
      );
      window.location.href = ` ${settingUrl}?variant=${variant_id}&view=final-ring&diamond=${diamond_information.cert_num}`;
    } else {
      // Clear diamond filter localstore if ring settings added first and diamond data is still not added.
      // theme.remove_local_storage("labDiamondFilterSetting");
      // theme.remove_local_storage("naturalDiamondFilterSetting");
      // Show popup to choose diamond type
      theme.open_popup($("#select-diamond-type-popup"));
    }
  });

  // Update setting value in localstorage
  $("#product-loop .product-card").on("click", function () {
    theme.set_local_storage("customRingStep", "engagement-rings");
  });

  // Remove diamond shape option from ring settings PDP if diamond is selected
  const get_selected_diamond = theme.get_local_storage("diamond-information");
  // disalbe diamond only for ring setting page
  const is_ring_settings_product = $(
    '[data-section-id="setting-product-template"]'
  );
  if (get_selected_diamond && is_ring_settings_product.length) {
    const selected_diamond_shape = JSON.parse(get_selected_diamond).shape;
    console.log(selected_diamond_shape);
    $(".swatch-shape .swatch-element").each(function () {
      if ($(this).data("value") !== selected_diamond_shape) {
        $(this).addClass("disabled");
      }
    });
  }
});
